export default __webpack_public_path__ + "static/media/dark.8e730893.svg";